import React from 'react';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px;
    flex-direction: column;
    gap: 16px;
  }
`;

const PaginationControls = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    gap: 8px;
  }
`;

const PaginationButton = styled.button`
  padding: 8px 16px;
  background: ${props => props.disabled ? '#e0e0e0' : '#007bff'};
  color: ${props => props.disabled ? '#999' : 'white'};
  border: none;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  transition: background 0.2s, transform 0.1s;

  &:hover {
    background: ${props => props.disabled ? '#e0e0e0' : '#0056b3'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.95)'};
  }

  @media (max-width: 768px) {
    min-height: 44px;
    padding: 12px 20px;
    font-size: 15px;
    flex: 1;
  }
`;

const PageInfo = styled.div`
  font-size: 14px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 13px;
    text-align: center;
    width: 100%;
  }
`;

const PageSizeSelector = styled.select`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 44px;
    padding: 12px;
    font-size: 15px;
  }
`;

const Pagination = ({
    currentPage,
    totalPages,
    totalElements,
    pageSize,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [10, 20, 50, 100]
}) => {
    const startItem = totalElements === 0 ? 0 : currentPage * pageSize + 1;
    const endItem = Math.min((currentPage + 1) * pageSize, totalElements);

    return (
        <PaginationContainer>
            <PageInfo>
                Showing {startItem}-{endItem} of {totalElements} files
            </PageInfo>

            <PaginationControls>
                <PaginationButton
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                >
                    Previous
                </PaginationButton>

                <PageInfo>
                    Page {currentPage + 1} of {totalPages || 1}
                </PageInfo>

                <PaginationButton
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages - 1}
                >
                    Next
                </PaginationButton>

                <PageSizeSelector
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                >
                    {pageSizeOptions.map(size => (
                        <option key={size} value={size}>
                            {size} per page
                        </option>
                    ))}
                </PageSizeSelector>
            </PaginationControls>
        </PaginationContainer>
    );
};

export default Pagination;
